import React from 'react';

function CopyModal({ onClose, text }) {
  return (
    <div id="popup-modal" tabIndex="-1" className="mx-auto w-full fixed inset-0 z-50 flex items-center justify-center overflow-auto bg-black/40">
      <div className="relative w-full max-w-lg max-h-full p-4">
        <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
          <button
            onClick={onClose}
            type="button"
            className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
            data-modal-hide="popup-modal"
          >
            <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
              <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
            </svg>
            <span className="sr-only">Close modal</span>
          </button>
          <div className="p-6 text-left pt-12">
            <h3 className="mb-4 text-lg font-semibold text-gray-900 dark:text-white">
              Le contenu a été copié
            </h3>
            <pre className="mb-5 text-sm font-normal text-gray-500 dark:text-gray-400 whitespace-pre-wrap break-words max-h-80 overflow-y-auto bg-gray-50 dark:bg-gray-800 rounded-lg p-4">
              {text}
            </pre>
            <div className="flex justify-end">
              <button
                onClick={onClose}
                type="button"
                className="text-white bg-primary hover:opacity-90 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
              >
                Fermer
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CopyModal;
